// Module
var code = "<div class=\"block height-100\"> <h2>Trackings setup across entities</h2> <div id=\"trackingsGrid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;